import React, { useEffect, useState } from 'react';
import { Title, Icon } from '../styles/commonStyle';
import styled from 'styled-components';
import { Content } from 'antd/lib/layout/layout';
import { KakaoPreviewImage } from './KakaoPreviewImage';
const matchedBody = (functionType, kakaoTemplate) => {
    // 특이사항: 수강권 만료 전 / 수강권 만료 시 는 "예약권 만료 전" / "예약권 만료 시"의 템플릿으로 우선 사용함.
    const match = kakaoTemplate.find(
        (tmp) => tmp.function_type === functionType,
    );

    return match
        ? `[${match.title}]\n${match.body}`
        : '템플릿 메세지가 없습니다.';
};

export const KakaoPreview = ({
    functionType,
    kakaoTemplate,
    handleOnchangePreview,
    isPreview,
}) => {
    const [kakaoMatchedBody, setKakaoMatchedBody] = useState(
        matchedBody(functionType, kakaoTemplate),
    );

    useEffect(() => {
        // 미리보기 버튼 누를 때
        if (isPreview) {
            setKakaoMatchedBody(handleOnchangePreview(kakaoMatchedBody));
            return;
        }
        setKakaoMatchedBody(matchedBody(functionType, kakaoTemplate));
    }, [isPreview, functionType]);
    return (
        <KakaoPreviewWrap>
            <KakaoPreviewTop>
                <span>15원/건</span>
            </KakaoPreviewTop>
            <KakaoPreviewBottom>
                {/* 상단 바 */}
                <KakaoPreviewTopBar>
                    <Title
                        style={{
                            fontSize: '12px',
                            fontWeight: '800',
                            color: '#000',
                        }}
                    >
                        {'< 브로제이'}
                    </Title>
                </KakaoPreviewTopBar>

                {/* 메시지 영역 */}
                <KakaoPreviewMessageWrap>
                    <Icon
                        style={{
                            margin: '3px 0 0 3px',
                            borderRadius: '50%',
                        }}
                        width="30px"
                        height="30px"
                        src={
                            process.env.PUBLIC_URL +
                            '/assets/images/icon/broj_logo.jpg'
                        }
                    />
                    <Content>
                        <KakaoPreviewProfilText>
                            브로제이
                        </KakaoPreviewProfilText>
                        {/* 알림톡 도착 헤더 */}
                        <MessageHeader>알림톡 도착</MessageHeader>

                        {/* 내용 */}
                        <MessageBody>
                            {/* 이미지 */}
                            <KakaoPreviewImage
                                functionType={functionType}
                                kakaoTemplate={kakaoTemplate}
                            />
                            {/* 내용, 템플릿에서 보내준 template body */}
                            {kakaoMatchedBody}
                        </MessageBody>
                    </Content>
                </KakaoPreviewMessageWrap>
            </KakaoPreviewBottom>
        </KakaoPreviewWrap>
    );
};

const KakaoPreviewWrap = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 0 0 20px;
    position: relative;
`;

const KakaoPreviewTopBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px 8px;
`;

const KakaoPreviewMessageWrap = styled.div`
    border-radius: 11px;
    margin: 0 16px 0 6px;
    padding: 0 0 8px;
    display: flex;
    gap: 4px;
`;

const KakaoPreviewProfilText = styled.div`
    font-size: 11px;
    color: gray;
    padding-left: 2px;
    margin-top: 3px;
`;

const MessageHeader = styled.div`
    background-color: #FFEB00;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 6px 12px;
    font-weight: bold;
    font-size: 12px;
    margin-top: 3px;
`;

const MessageBody = styled.div`
    background-color: #fff;
    border-radius: 0 0 8px 8px;
    padding: 12px 8px;
    font-size: 11px;
    line-height: 1.6;
    white-space: pre-line;
    word-break: break-word;
`;
const KakaoPreviewTop = styled.div`
    display: flex;
    justify-content: end;
    padding-top: 4px;
    font-size: 12px;
    color: #888;
    position: absolute;
    top: -5px;
    right: 2px;
`;

const KakaoPreviewBottom = styled.div`
    width: 235px;
    min-height: 365px;
    height: max-content;
    background: #c1d6e6;
    border-radius: 16px;
    padding: 5px 0 16px 0;
    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
    position: relative;
`;
